import { render, staticRenderFns } from "./uf_industry_id.vue?vue&type=template&id=e5be34d4&scoped=true"
import script from "./uf_industry_id.vue?vue&type=script&lang=js"
export * from "./uf_industry_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5be34d4",
  null
  
)

export default component.exports